import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatButtonModule} from '@angular/material/button';
import { ErrorSnackBar } from './error-snack-bar.component';

@NgModule({
  declarations: [
    ErrorSnackBar
  ],
  imports: [
    CommonModule,
    MatButtonModule
  ],
  exports: [
    ErrorSnackBar
  ]
})
export class ErrorSnackBarModule { }
